import { __require as i } from "./index.es222.js";
var r, e;
function u() {
  return e || (e = 1, r = i()), r;
}
export {
  u as __require
};
//# sourceMappingURL=index.es221.js.map
